<template>
	<ActivityLayout class="goal-team-activity">
		<template #badge>
			<TeamChangeActivityBadge />
		</template>
		<template #text>
			<p>{{ translate( "text", { changedBy: activity.changedBy } ) }}</p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import TeamChangeActivityBadge from "../Activity/TeamChangeActivityBadge";

export default {
	name: "GoalTeamActivity",
	components: {
		ActivityLayout,
		TeamChangeActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String, to:String, from:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.GoalTeamActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
